import { useEffect } from "react";
import { useSelector } from "react-redux";
import { hotjar } from "react-hotjar";

import Header from "./ui/Header";
import Months from "./ui/Months";
import Practicas from "../src/screens/Practicas/Practicas";
import Teoria from "../src/screens/Teoria/Teoria";
import Extras from "../src/screens/Extras/Extras";
import Resumen from "../src/screens/Resumen/Resumen";
import ErrorScreen from "../src/screens/ErrorScreen/ErrorScreen";

import "./App.css";

import { useTranslation } from "react-i18next";

const App = () => {
  const [t, i18n] = useTranslation("global");
  const screen = useSelector((state) => state.screens.mainScreen);

  useEffect(() => {
    hotjar.initialize("2505763", 6); //hotjar initialization
    changeAppLanguage();
  }, []);

  //Set app language by GET parameter ?lang=
  const changeAppLanguage = () => {
    const search = new URLSearchParams(window.location.search).get("lang");

    let lang;

    if (search) {
      if (search == "en" || search == "EN") {
        lang = "en";
      } else if (search == "cat" || search == "CAT") {
        lang = "cat";
      } else {
        lang = "es";
      }
    } else {
      lang = "es";
    }

    i18n.changeLanguage(lang);
  };

  //Render which screen will be shown in the app
  let renderScreen;

  if (screen == "practicas") {
    renderScreen = <Practicas />;
  } else if (screen == "teoria") {
    renderScreen = <Teoria />;
  } else if (screen == "extras") {
    renderScreen = <Extras />;
  } else if (screen == "resumen") {
    renderScreen = <Resumen />;
  } else if (screen === "errorscreen") {
    renderScreen = <ErrorScreen />;
  }

  return (
    <div className="container">
      <Header />
      {/* Months' component will be shown only if the selected screen is "practicas" */}
      {screen == "practicas" && <Months />}
      {renderScreen}
    </div>
  );
};

export default App;
